<template>
  <v-card  color="grey lighten-4" height="auto" tile>
    <v-toolbar color="#58575c">
      <v-toolbar-title class="white--text">Dögel.  </v-toolbar-title>
            <v-toolbar-title class="deep-orange--text"> Forecasting </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link v-for="item in items" :key="item.title" :to="item.to">
        <v-btn    text  v-bind:class="item.name==routeComputed?'white--text':'deep-orange--text'"> {{ item.title }}</v-btn>
      </router-link>
     
    </v-toolbar> 
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      items: [
        { title: "Dashboard",name:"dashboard", to: "/forecast/view/dashboard", show: true },
        { title: "Jahren-Vergleichen",name:"compile", to: "/forecast/view/compile", show: true },
        { title: "Diagramme", name:"diagramm",to: "/forecast/view/diagramm", show: true },
        { title: "Forecast-Vergleichen",name: "compileHistory", to:'compileHistory',show:true},
      ],
    };
  },
  created() {
  },
  computed:{
    routeComputed(){
     return this.$route.name
    },
  },
  methods:{
  }
  
 
}
</script>
<style lang="stylus"></style>